var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{ 'ic-content':_vm.$route.name!='cover' },attrs:{"role":'cid-'+_vm.cid}},[_c('router-view'),_c('div',{staticStyle:{"font-size":"10px","text-align":"center","font-style":"italic","display":"none"}},[_vm._v("v1.0")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }